import React, { useState } from 'react';
import { FiGrid, FiSettings, FiTool } from 'react-icons/fi';
import { theme } from '../theme';

interface Tab {
  id: string;
  label: string;
  icon: React.ReactNode;
  component: React.ReactNode;
}

interface FabricaTabsProps {
  sectoresComponent: React.ReactNode;
  equiposComponent: React.ReactNode;
  motoresComponent: React.ReactNode;
}

export const FabricaTabs: React.FC<FabricaTabsProps> = ({
  sectoresComponent,
  equiposComponent,
  motoresComponent
}) => {
  const [activeTab, setActiveTab] = useState('sectores');

  const tabs: Tab[] = [
    {
      id: 'sectores',
      label: 'Sectores',
      icon: React.createElement(FiGrid as any),
      component: sectoresComponent
    },
    {
      id: 'equipos',
      label: 'Equipos',
      icon: React.createElement(FiSettings as any),
      component: equiposComponent
    },
    {
      id: 'motores',
      label: 'Motores',
      icon: React.createElement(FiTool as any),
      component: motoresComponent
    }
  ];

  return (
    <div style={{ width: '100%' }}>
      {/* Pestañas */}
      <div style={{ 
        borderBottom: `1px solid ${theme.colors.borderLight}`,
        marginBottom: '24px'
      }}>
        <nav style={{ 
          display: 'flex',
          gap: '32px',
          marginBottom: '-1px'
        }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '12px 4px',
                borderBottom: `2px solid ${activeTab === tab.id ? theme.colors.secondary : 'transparent'}`,
                color: activeTab === tab.id ? theme.colors.secondary : theme.colors.textSecondary,
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: theme.fontSizes.normal,
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.3s ease',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.color = theme.colors.textPrimary;
                }
              }}
              onMouseLeave={(e) => {
                if (activeTab !== tab.id) {
                  e.currentTarget.style.color = theme.colors.textSecondary;
                }
              }}
            >
              {tab.icon}
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Contenido de las pestañas */}
      <div>
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

